import {
    useParams
} from "react-router-dom";
import Event from "../../components/Events/EventPage/Event";

import '../../assets/styles/events/conferencePage/conferencePage.scss';
import useEventData from "../../components/Events/hooks/useEventData";

export default function EventPage() {
    const { id } = useParams();
    const [eventData, dispatch] = useEventData(id);

    if (!eventData) {
        return null;
    }

    return <Event
        event={eventData.event}
        userData={eventData.userData}
        childEvents={eventData.childEvents}
        eventDataUpdate={dispatch}
    /> ;
}
